type Theme = 'white' | 'orange' | 'blue' | 'green' | null;

export type BubbleFeatureObject = { bubbleValue: string; text: string };

export type ParagraphFeature = {
  text: string;
  isBold?: boolean;
};

export type BillingPlanDefinition = {
  name: string;
  price?: string;
  featuresList: ParagraphFeature[];
  oldPrice?: string;
  bubbleFeatures?: BubbleFeatureObject[];
  theme: Theme;
  paragraphFeature?: ParagraphFeature[];
  descriptionText: string;
};

export type PanelPlanTypes = 'free' | 'pro' | 'unicorn' | 'team';

export const defaultPlanValues = {
  pro: {
    price: '19',
    oldPrice: '49',
    sendLimit: '2K',
    page: '1',
    prices: [49],
  },
  unicorn: {
    price: '119',
    oldPrice: '108',
    sendLimit: '6.5K',
    page: '1',
    prices: [119],
  },
  team: {
    price: '199',
    oldPrice: '395',
    sendLimit: '100K',
    page: '5',
    prices: [279],
  },
};
